<template>
  <div class="grid grid-cols-2 lg:grid-cols-3 gap-8">
    <div class="flex flex-col lg:col-span-2 gap-2 lg:gap-4">
      <div class="w-full aspect-video bg-neutral-900 relative border-none">
        <div class="py-4 px-4 absolute bg-blue-600 font-bold shadow-2xl top-2 left-2"
             v-if="selectedQuest && selectedQuest.publication_date && !hasMoreThan24HoursPassed(selectedQuest?.publication_date)">
          2X Boost ends in
          <LiteCountDownTimer :targetDate="add24hToPublishDate(selectedQuest?.publication_date)" />
        </div>
        <img
          class="w-full aspect-video bg-neutral-900 border-none"
          :src="selectedQuest?.image"
          @load="imgIsLoaded = true"
          alt="Albarra episode"
        />
        <div
          class="w-full h-full z-10 bg-black flex items-center justify-center absolute top-0 left-0"
          v-if="!imgIsLoaded"
        >
          <Typography size="main-l" class="text-primary">Loading...</Typography>
        </div>
      </div>
      <div class="flex flex-col gap-2">
        <Typography size="main-md" class="text-lg font-bold">Timeline</Typography>
        <div ref="scrollContainer" class="flex gap-4 lg:pt-2 pb-5 lg:pb-2 lokie-scrollbar-container">
          <img
            v-for="quest in quests"
            :key="quest.id"
            :src="quest?.image"
            :class="{
              'aspect-video h-14 bg-neutral-800 cursor-pointer transition': true,
              'border border-primary ': selectedQuest?.id === quest.id,
            }"
            @click="selectQuest(quest)"
          />
          <div
            class="aspect-video text-sm font-semibold h-14 bg-neutral-900 flex items-center justify-center border border-dashed border-neutral-600"
          >
            Next week
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col lg:gap-4" v-if="selectedQuest">
      <div class="flex justify-between items-center">
        <span class="flex gap-2 items-center">
          <Typography size="main-md-num" class="text-primary">
            {{ selectedQuest.number }}.</Typography
          >
          <Typography size="main-md" class=""
            >{{ selectedQuest.title }}</Typography
          >
        </span>
        <count-down-timer v-if="!selectedQuest.isExpiredQuest" :targetDate="selectedQuest.end" />
      </div>
      <Typography size="secondary-sm">{{ selectedQuest.content }}</Typography>
      <div class="flex flex-col gap-2 lg:gap-8">
        <div class="w-full flex gap-4 items-end" v-if="selectedQuest?.type !== 'end_season'">
          <div class="flex-1 h-3 bg-neutral-600 relative overflow-hidden">
            <div class="h-full bg-primary absolute" :style="{ width: `${(selectedQuest.logs / selectedQuest.total) * 100}%` }"></div>
          </div>
          <div class="flex whitespace-nowrap flex-row text-3xl items-end gap-4 font-extrabold">
            <img src="~/assets/svg/troncos.svg" alt="woods" class="h-6 w-6" />
            <Typography size="main-l-num">{{ selectedQuest.logs }} / {{ selectedQuest.total }}</Typography>
          </div>
        </div>
        <span class="w-full flex flex-col gap-2">
          <button v-if="buttonState === 'complete-quest'"
                  class="py-1 md:py-3 lg:py-4 min-w-36 rounded border border-primary hover:bg-primary transition-all"
                  @click="onCompleteQuest(bonusQuest)">
            <Typography size="main-sm">Complete full quest to claim</Typography>
          </button>
          <button v-if="buttonState === 'expired-quests'"
                  class="py-1 md:py-3 lg:py-4 min-w-36 rounded border border-primary transition-all"
                  :disabled="true">
            <Typography size="main-sm">Expired</Typography>
          </button>
          <button v-if="buttonState === 'verify-quest'"
                  class="py-1 md:py-3 lg:py-4 min-w-36 w-full bg-primary font-bold text-2xl"
                  :class="{ 'opacity-50': disabledButton }"
                  :disabled="disabledButton"
                  @click="onClaimStoryQuests">
            <Typography size="main-l">Verify & Claim</Typography>
          </button>
          <button v-if="buttonState === 'completed-quests'"
                  class="py-1 md:py-3 lg:py-4 min-w-36 w-full bg-primary font-bold text-2xl"
                  :class="{ 'opacity-50': true }"
                  :disabled="true">
            <Typography size="main-l">Quest completed</Typography>
          </button>
          <button v-if="buttonState === 'check-eligibility'"
                  class="py-1 md:py-3 lg:py-4 min-w-36 rounded border border-primary hover:bg-primary transition-all"
                  :class="{ 'opacity-50': disabledButton }"
                  :disabled="disabledButton"
                  @click="onCheckEligibility">
            <Typography size="main-sm">Check eligibility</Typography>
          </button>
          <button v-if="buttonState === 'loading'"
                  class="py-1 md:py-3 lg:py-4 min-w-36 w-full bg-primary font-bold text-2xl"
                  :class="{ 'opacity-50': disabledButton }"
                  :disabled="disabledButton">
            <Typography size="main-l">Loading...</Typography>
          </button>
          <p class="text-xs lg:text-sm font-light text-center">
            * Please be patient, some verifications may take some time fren
          </p>
          
          <!-- Buttons row for end_season quests -->
          <div v-if="selectedQuest?.type === 'end_season' && (buttonState === 'completed-quests' || buttonState === 'complete-quest')"
               class="mt-10 flex gap-4 w-full">
            <!--
            <button @click="onClickShare"
                    class="flex-1 py-2 md:py-3 lg:py-4 rounded border bg-primary border-primary hover:bg-primary transition-all flex items-center justify-center gap-3">
              <Typography size="main-md">Share on </Typography>
              <img src="/x.svg" alt="X" class="w-5 h-5" />
            </button>
            <button @click="onCheckEligibilityView"
                    class="flex-1 py-2 md:py-3 lg:py-4 rounded border border-primary hover:bg-primary transition-all flex items-center justify-center gap-3">
              <Typography size="main-md">Checker</Typography>
            </button>
            -->
          </div>
          
        </span>
      </div>
      <div class="mx-auto my-4 mb-8 lg:my-12 lg:mb-4 relative rounded border border-primary p-6 gap-4 w-80" v-if="selectedQuest?.type !== 'end_season'">
        <div class="flex gap-2 absolute h-8 items-center top-0 left-0 -translate-y-[50%] -translate-x-4 p-2 bg-black font-bold text-primary">
          <Typography size="main-l"> Point System </Typography>
        </div>
        <ul class="w-full flex flex-col">
          <li
            class="w-full flex justify-between items-center h-8"
            v-for="pointSystem in pointSystems"
            :key="pointSystem.type"
          >
            <Typography size="main-md">{{ pointSystem.type }}</Typography>
            <span class="flex gap-2 items-center h-8">
              <img src="~/assets/svg/troncos.svg" alt="woods" class="h-4 w-4" />
              <Typography size="main-md-num">{{ pointSystem.points }}</Typography>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import Typography from "@/components/common/Typography.vue";
import LiteCountDownTimer from "./lite-count-down-timer.vue";
import { cmsStore } from "../stores/cmsStore";
import { useClaimsStore } from "../stores/useClaimsStore";
import { useModalsStore } from "../stores/useModalsStore";
import { useAuthStore } from "../stores/useAuthStore";
import { useDeepDebug } from "../composables/useDeepDebug";
import { sleep } from "../utils/time.utils";
import { DateTime } from 'luxon'

const cms = cmsStore();
const claimsStore = useClaimsStore()
const modalsStore = useModalsStore()
const authStore = useAuthStore()
const { isDeepDebugMode } = useDeepDebug()
const selectedQuest = ref(null)
const buttonState = ref('complete-quest')
const quests = ref([])
const imgIsLoaded = ref(false)
const totals = ref(0)
const scrollContainer = ref(null)
const disabledButton = computed(() => {
  return selectedQuest.value.logs === selectedQuest.value.total || buttonState.value === 'loading'
})
const assetsUrl = useRuntimeConfig().public.assetsUrl

const pointSystems = ref([
  { type: "Like", points: 4 },
  { type: "Comment", points: 6 },
  { type: "Retweet", points: 10 },
])

function selectQuest(quest) {
  selectedQuest.value = quest
  const now = new Date()
  const endPublicationDate = new Date(quest.end)
  const isExpiredQuest = now > endPublicationDate
  selectedQuest.value.isExpiredQuest = isExpiredQuest
  buttonState.value = quest.type === 'end_season' ? 'check-eligibility' : 'complete-quest'
  if (isExpiredQuest) {
    buttonState.value = 'expired-quests'
  }
  if (!authStore.isAuthenticated) return
  checkClaimedStoryQuests()
    .then(() => {
      console.log(selectedQuest.value)
    })
}

function formatDateToISO(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  const hours = String(date.getHours()).padStart(2, "0")
  const minutes = String(date.getMinutes()).padStart(2, "0")
  const seconds = String(date.getSeconds()).padStart(2, "0")

  const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`

  return formattedDate
}

const loadTimeline = async () => {
  const collectionParams = {
    filter: {
      publication_date: {
          '_lt': formatDateToISO(new Date())
      },
    },
  }
  
  // Solo filtrar por status 'published' si NO estamos en modo deep debug
  if (!isDeepDebugMode.value) {
    collectionParams.filter.status = {
      '_eq': 'published'
    }
  }
  
  // Pasar el parámetro deepdebug al backend
  if (isDeepDebugMode.value) {
    collectionParams.deepdebug = true
  }
  
  let episodesResponse = await cms.get("episode", collectionParams)
  let episodes = episodesResponse.data

  episodes.sort((a, b) => new Date(a.publication_date) - new Date(b.publication_date))
  episodes = episodes.map((episode, idx) => {
    const { retweet_logs, like_logs, comment_logs } = episode
    const total = retweet_logs + like_logs + comment_logs
    return {
      ...episode,
      id: episode.id,
      number: idx + 1,
      title: episode.title,
      content: episode.content,
      timeRemaining: "6d 8h 12min",
      logs: 0,
      total,
      tokens: episode.tokens,
      image: `${assetsUrl}/${episode.image}`,
    }
  })
  quests.value = episodes
};

const onCompleteQuest = async (quest) => {
  const twitterLink = selectedQuest.value.twitter_link
  if (twitterLink) {
    window.open(twitterLink, '_blank')
    buttonState.value = 'verify-quest'
  }
}

const onCheckEligibility = async () => {
  console.log('run > onCheckEligibility')
  if (!authStore.isAuthenticated) return modalsStore.openModal('LOGIN')
  console.log(selectedQuest.value);
  
  try {
    buttonState.value = 'loading'
    const response = await claimsStore.requestCheckEligibility({ episode_id: selectedQuest.value.id })
    console.log('Eligibility response:', response)
    
    if (response && response.code === 'eligibility_checked_and_claimed') {
      modalsStore.openModal('ELIGIBILITY_RESULT', {
        nft: response.nft,
        apecoin: response.apecoin,
        badge: response.badge
      })
      buttonState.value = 'completed-quests'
      await cms.loadNotifications()
      await cms.loadUserLogs()
    } else {
      console.error('Error checking eligibility:', response)
      buttonState.value = 'check-eligibility'
    }
  } catch (error) {
    console.error('Error in onCheckEligibility:', error)
    buttonState.value = 'check-eligibility'
  }
}

const onClaimStoryQuests = async () => {
  try {
    if (!authStore.isAuthenticated) return modalsStore.openModal('LOGIN')
    buttonState.value = 'loading'
    const AWAIT_30_SECONDS = 30000
    await sleep(AWAIT_30_SECONDS)
    const response = await claimsStore.requestClaimStoryQuests({ episode_id: selectedQuest.value.id })
    const { retweet_logs, like_logs, comment_logs } = selectedQuest.value
    selectedQuest.value.total = retweet_logs + like_logs + comment_logs
    selectedQuest.value.logs = 0
    if (response.liked) selectedQuest.value.logs += like_logs
    if (response.commented) selectedQuest.value.logs += comment_logs
    if (response.retweeted) selectedQuest.value.logs += retweet_logs
    if (response.code === 'claimed_completed') {
      if (selectedQuest.value.logs === selectedQuest.value.total) {
        modalsStore.openModal('SUCCESS_STORY_QUESTS')
        buttonState.value = 'completed-quests'
      }
    } else if (response.code === 'claimed_not_completed') {
      buttonState.value = 'complete-quest'
    } else if (response.code === 'too_many_requests') {
      modalsStore.openModal('ERROR_TOO_MANY_REQUESTS')
    } else {
      modalsStore.openModal('ERROR_STORY_QUESTS')
    }
    await cms.loadNotifications()
    await cms.loadUserLogs()
  } catch (error) {
    console.error(error)
    if (error.data && error.data.code === 'too_many_requests') {
      modalsStore.openModal('ERROR_TOO_MANY_REQUESTS')
    } else {
      modalsStore.openModal('ERROR_STORY_QUESTS')
    }
  }
}

const checkClaimedStoryQuests = async () => {
  const response = await claimsStore.checkClaimedStoryQuests({ episode_id: selectedQuest.value.id })
  if (response.data.length > 0) {
    const claimed = response.data[0]
    const { retweet_logs, like_logs, comment_logs } = selectedQuest.value
    selectedQuest.value.total = retweet_logs + like_logs + comment_logs
    selectedQuest.value.logs = 0
    if (claimed.liked) selectedQuest.value.logs += like_logs
    if (claimed.commented) selectedQuest.value.logs += comment_logs
    if (claimed.retweeted) selectedQuest.value.logs += retweet_logs
    if (selectedQuest.value.logs === selectedQuest.value.total) {
      buttonState.value = 'completed-quests'
    }
  }
}

function hasMoreThan24HoursPassed(publishDate) {
  if (!publishDate) return false
  const publishedDate = new Date(publishDate)
  const currentDate = new Date()
  const diff = currentDate - publishedDate
  const hoursPassed = diff / (1000 * 60 * 60)
  return hoursPassed > 24
}

function add24hToPublishDate(publishDate) {
  const dt = DateTime.fromISO(publishDate, { zone: 'utc' })
  const newDt = dt.plus({ hours: 24 })
  return newDt.toISO();
}

const scrollToEnd = () => {
  console.log('scrollToEnd')
  const container = scrollContainer.value
  if (container) {
    container.scrollLeft = container.scrollWidth
  }
}

const onCheckEligibilityView = async () => {
  try {
    const response = await $fetch('/api/user/eligibility', {
      method: 'GET',
      credentials: 'include'
    });
    
    if (response.eligibility) {
      modalsStore.openModal("ELIGIBILITY_VIEW", response.eligibility);
    }
  } catch (error) {
    console.error('Error checking eligibility:', error);
  }
};

const onClickShare = () => {
  const text = encodeURIComponent('I just set my wallet in albarra.world to receive the airdrop of my @albarra_tdrc pilot season rewards! 🪵🪓')
  const url = `https://twitter.com/intent/tweet?text=${text}`
  window.open(url, '_blank')
}

onMounted(() => {
  loadTimeline().then(() => {
    if (quests.value.length > 0) {
      const lastQuest = quests.value[quests.value.length - 1]
      selectQuest(lastQuest)
    }
    if (authStore.isAuthenticated)
      return checkClaimedStoryQuests()
  })
  .finally(() => {
    scrollToEnd()
  })
})

</script>
